module.exports = __webpack_public_path__ + "img/icon-not-complete.0ffd4758.svg";